module.exports = __RENDER_7_COMPONENTS__['vtex.styleguide@6.x/Spinner'];